import { Button, Tooltip } from "@material-ui/core";
import {
	Description,
	Link,
	Send,
	ToggleOff,
	ToggleOn,
} from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { SERVER_URL } from "../../../../api";
import {
	changeStatusNotification,
	deleteNotification,
	getNotifications,
	sendNotification,
} from "../../../../api/notification";
import { getNonEmpty } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
	buttonsStyle,
	dateFormatter,
	imageFormatter,
} from "../../../components/tables/table";

function getData(notifications) {
	let data = [];
	for (let i = 0; i < notifications.length; ++i) {
		const elem = {};

		elem.title = getNonEmpty(notifications[i].title);
		elem.imageURL = notifications[i].imageURL;
		elem.fileURL = notifications[i].fileURL;
		elem.linkURL = notifications[i].linkURL;
		elem.active = notifications[i].active;
		elem.createdAt = notifications[i].createdAt;
		elem.id = notifications[i]._id;

		data = data.concat(elem);
	}

	return data;
}

export default function NotificationsPage() {
	const [data, setData] = useState([]);
	const [selectedNotification, setSelectedNotification] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Enviar notificación">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => {
							setSelectedNotification(elem);
							setOpenConfirmDialog(1);
						}}
					>
						<Send />
					</Button>
				</Tooltip>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() =>
							history.push("/edit-notification/" + cell)
						}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{elem?.fileURL && (
					<Tooltip title="Ver archivo">
						<Button
							style={buttonsStyle}
							size="small"
							onClick={() =>
								window
									.open(
										`${SERVER_URL}/${elem.fileURL}`,
										"_blank"
									)
									.focus()
							}
						>
							<Description />
						</Button>
					</Tooltip>
				)}
				{elem?.linkURL && (
					<Tooltip title="Ver enlace">
						<Button
							style={buttonsStyle}
							size="small"
							onClick={() =>
								window.open(elem.linkURL, "_blank").focus()
							}
						>
							<Link />
						</Button>
					</Tooltip>
				)}
				{user?.role === "admin" && (
					<>
						<Tooltip
							title={elem?.active ? "Desactivar" : "Activar"}
						>
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setSelectedNotification(elem);
									setOpenConfirmDialog(3);
								}}
							>
								{elem?.active ? (
									<ToggleOff />
								) : (
									<ToggleOn style={{ color: "red" }} />
								)}
							</Button>
						</Tooltip>
						<Tooltip title="Eliminar">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setSelectedNotification(elem);
									setOpenConfirmDialog(2);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	const columns = [
		{
			dataField: "imageURL",
			text: "",
			headerAlign: "center",
			align: "center",
			formatter: imageFormatter,
		},
		{ dataField: "title", text: "Título", sort: true },
		{
			dataField: "createdAt",
			text: "Created at",
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getNotifications("?getDisabled=true")
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get notifications.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Listado de notificaciones">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => history.push("/edit-notification")}
						>
							Añadir
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={
							"¿Estás seguro de que quieres enviar esta notificación a todas las familias?"
						}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							sendNotification(selectedNotification?.id)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "¡Enviada!",
											customMessage:
												"Notificación enviada con éxito.",
										});
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"Could not remove notification.",
									});
								});
						}}
					/>
					<ConfirmDialog
						title={
							"¿Estás seguro de que quieres eliminar esta notificación?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteNotification(selectedNotification?.id)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "¡Eliminada!",
											customMessage:
												"Notificación eliminada con éxito.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"Could not remove notification.",
									});
								});
						}}
					/>
					<ConfirmDialog
						title={`¿Estás seguro de que quieres ${
							selectedNotification?.active
								? "desactivar"
								: "activar"
						} esta notificación?`}
						open={openConfirmDialog === 3}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusNotification(
								selectedNotification.id,
								!selectedNotification?.active
							)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({
											title: `${
												selectedNotification?.active
													? "¡Desactivada!"
													: "¡Activada!"
											}`,
											customMessage: `Notificación ${
												selectedNotification?.active
													? "desactivada"
													: "activada"
											} con éxito`,
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: `Could not ${
											selectedNotification?.active
												? "disable"
												: "enable"
										} alert.`,
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
